// SessionWarningModal.js
import React from "react";

export default function SessionWarningModal({
  isOpen,
  timeLeft,
  onStayConnected,
  onLogout,
}) {
  if (!isOpen) return null;

  const secondsLeft = Math.ceil(timeLeft / 1000);
  const circumference = 2 * Math.PI * 45; // r=45 (SVG viewBox 0..100)
  // clamp secondsLeft to max 60 so circle works well:
  const clamped = Math.max(0, Math.min(60, secondsLeft));
  const dashOffset = circumference - (circumference * clamped) / 60;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] md:w-[500px] p-6 relative text-center">
        <h2 className="text-lg font-semibold text-black mb-4">
          Session Warning
        </h2>

        <div className="flex justify-center items-center mb-4">
          <div className="relative w-24 h-24 flex items-center justify-center">
            <svg
              className="absolute inset-0 w-full h-full"
              viewBox="0 0 100 100"
            >
              <circle
                cx="50"
                cy="50"
                r="45"
                stroke="#e5e7eb"
                strokeWidth="8"
                fill="transparent"
              />
              <circle
                cx="50"
                cy="50"
                r="45"
                stroke="#ef4444"
                strokeWidth="8"
                fill="transparent"
                strokeDasharray={circumference}
                strokeDashoffset={dashOffset}
                strokeLinecap="round"
              />
            </svg>
            <span className="text-2xl font-bold">{secondsLeft}</span>
          </div>
        </div>

        <p className="text-gray-700 mb-6">
          Your session is expiring. If it expires, all unsaved data will be
          lost. Would you like to stay connected?
        </p>

        <div className="flex justify-center gap-4">
          <button
            onClick={onStayConnected}
            className="bg-[#003478] text-white px-4 py-2 rounded-lg"
          >
            Stay Connected
          </button>
          <button
            onClick={onLogout}
            className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
